/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Source_SubtitleInputs */

const en_ui_onboarding_source_subtitle = /** @type {(inputs: Ui_Onboarding_Source_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick one — you can add another source later.`)
};

const de_ui_onboarding_source_subtitle = /** @type {(inputs: Ui_Onboarding_Source_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine – weitere Quellen kannst du später ergänzen.`)
};

/**
* | output |
* | --- |
* | "Pick one — you can add another source later." |
*
* @param {Ui_Onboarding_Source_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_source_subtitle = /** @type {((inputs?: Ui_Onboarding_Source_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Source_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_source_subtitle(inputs)
	return de_ui_onboarding_source_subtitle(inputs)
});